import { render, staticRenderFns } from "./RejectJustification.vue?vue&type=template&id=e57e950e&scoped=true&"
import script from "./RejectJustification.vue?vue&type=script&lang=js&"
export * from "./RejectJustification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57e950e",
  null
  
)

export default component.exports